import { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import api from '../api/axios';

/**
 * 支払いメールのマジックリンクハンドラー。
 * /pay/magic?token=xxx&rid=123 でアクセスされる。
 * トークンを検証 → localStorage にJWT保存 → /mypage/records?rid=xxx&open_payment=true へリダイレクト。
 */
export default function MagicPayment() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const { login } = useAuth();

  useEffect(() => {
    const token = searchParams.get('token');
    const rid   = searchParams.get('rid');

    if (!token) {
      navigate('/', { replace: true });
      return;
    }

    api.get(`/auth/magic-login?token=${encodeURIComponent(token)}`)
      .then((res) => {
        login(res.data.access_token, res.data.role || 'user', 'email');
        // rid は JWT から取得（URL の rid パラメータは使わない）
        const resolvedRid = res.data.reservation_id ?? rid;
        const target = resolvedRid
          ? `/mypage/records?rid=${resolvedRid}&open_payment=true`
          : '/mypage/records';
        navigate(target, { replace: true });
      })
      .catch(() => {
        // トークン無効 → LP へ
        navigate('/', { replace: true });
      });
  }, [searchParams, navigate, login]); // eslint-disable-line react-hooks/exhaustive-deps -- 意図的: 初回マウント時のみ実行

  return (
    <div style={{
      minHeight: '100dvh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      background: '#fff9f8',
      fontFamily: 'system-ui, sans-serif',
    }}>
      <div style={{ textAlign: 'center', color: '#888' }}>
        <div style={{
          width: '40px',
          height: '40px',
          border: '3px solid #e8694a',
          borderTopColor: 'transparent',
          borderRadius: '50%',
          animation: 'spin 0.8s linear infinite',
          margin: '0 auto 16px',
        }} />
        <style>{`@keyframes spin { to { transform: rotate(360deg); } }`}</style>
        <p style={{ margin: 0, fontSize: '14px' }}>ログイン中...</p>
        <p style={{ margin: '4px 0 0', fontSize: '12px', color: '#bbb' }}>登录中，请稍候</p>
      </div>
    </div>
  );
}
